module.exports = __webpack_public_path__ + "img/bandeja_entrada.f909ea5f.png";